// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/dist/cjs.js??ref--7-oneOf-0-1!../../../vue-loader/lib/loaders/stylePostLoader.js!../../../postcss-loader/src/index.js??ref--7-oneOf-0-2!../../../sass-loader/dist/cjs.js??ref--7-oneOf-0-3!../../../@nuxt/components/dist/loader.js??ref--0-0!../../../vue-loader/lib/index.js??vue-loader-options!./NsProductOffer.vue?vue&type=style&index=0&lang=scss&module=true&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("62a8a644", content, true, {"sourceMap":false});